import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class FormRoute extends Route {
  model() {}

  setupController(controller /*, model*/) {
    super.setupController(...arguments);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
    set(controller, 'step', 0);
  }
}
